module.exports = __webpack_public_path__ + "static/media/guadalupe_jimena.94392b2b.png";